import type { ProjectGraphIpcAncestor } from '@avisoma/shared';
import { ancestorLabel } from './ipcAncestors';

/** One indent step per level of the assembly chain, in px. */
const INDENT = 12;

/**
 * DR-5084: the assemblies above an IPC position, top of the figure first, each level a step deeper. `[]`: the position
 * is at the top of its figure. Absent (not computed): nothing.
 */
export function IpcAncestry({ ancestors }: { ancestors: ProjectGraphIpcAncestor[] | undefined }) {
  if (ancestors === undefined) return null;
  if (ancestors.length === 0) return <div className="text-zinc-500 dark:text-zinc-400">Top of its figure</div>;
  return (
    <div className="text-zinc-500 dark:text-zinc-400">
      <div>Assembly</div>
      <ol>
        {ancestors.map((ancestor, depth) => (
          <li key={`${depth}|${ancestor.item}`} className="break-words" style={{ paddingLeft: depth * INDENT }}>
            {ancestorLabel(ancestor)}
          </li>
        ))}
      </ol>
    </div>
  );
}
